import React from "react";

import { Box } from "@material-ui/core";

//               Unicode    HTML      CSS/JavaScript
// Outlined: Ⓟ   U+24C5    &#9413;    \24C5
// Filled:   🅟   U+1F15F   &#x24C5;

export const ParkingIcon = ({ ml = 0, mt = 0 }) => {
  return (
    <Box
      component="span"
      fontSize="20px"
      ml={ml}
      mt={mt}
      fontWeight="bold"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
    >
      {`\u{1F15F}`}
    </Box>
  );
};
